<template>
  <div class="template">
     <div class="search">
      <div class="search-center">
        <div class="search-item">
            <Input clearable
            v-model="search.orderNo"
            placeholder="订单号"
            style="width: 150px;"
            ></Input>
        </div>
        <div class="search-item" style="width: 150px;">
          <Select v-model="search.type" placeholder="请选择订单类型">
            <Option value="">类型</Option>
            <Option value="1">消费增加</Option>
            <Option value="2">使用扣除</Option>
            <Option value="3">取消/退款返还</Option>
            <Option value="4">提现扣除</Option>
            <Option value="5">推荐赠送</Option>
            <Option value="6">推荐人首次下单</Option>
          </Select>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.commend"
                 placeholder="备注"
                 style="width: 150px;"
          ></Input>
        </div>
         <Button
          style="width: 80px;margin-right: 10px;margin-bottom:5px"
          type="primary"
          icon="ios-search"
          @click="searchFn"
          >查询</Button>
      </div>
    </div>
    <div class="table">
      <Table
        :columns="diyData.columns"
        :data="apiData.tableList"
      >
        <template slot="footer">
          <Button size="large" @click="$router.go(-1)">返回</Button>
             <Page
            :total="apiData.total"
            show-total
            :page-size="search.pageSize"
            :current="search.pageNo"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            class-name="footer-page"
            show-elevator
            show-sizer
          ></Page>
        </template>
      </Table>
    </div>

  </div>
</template>

<script>
import { apiScoredetailList } from '@/api/user-manage.js'
export default {
  name: 'points-details',
  data () {
    return {
      query: {},
      search: {
        orderNo: '',
        type: '',
        phone: '',
        commend: '',
        userId: '',
        pageNo: 1,
        pageSize: 10
      },
      diyDom: {
        showModal: false
      },
      diyData: {
        orderNo: '',
        columns: [
          {
            title: '变动前',
            key: 'beforeScore'
          },
          {
            title: '变动积分',
            key: 'score'
          },
          {
            title: '变动后',
            key: 'afterScore'
          },
          {
            title: '变动类型',
            key: 'type',
            render: (h, params) => {
              var text = ''
              if (params.row.type == 1) {
                text = '消费增加'
              } else if (params.row.type == 2) {
                text = '使用扣除'
              } else if (params.row.type == 3) {
                text = '取消/退款返还'
              } else if (params.row.type == 4) {
                text = '提现扣除'
              } else if (params.row.type == 5) {
                text = '推荐赠送'
              } else if (params.row.type == 6) {
                text = '推荐人首次下单'
              }
              return h('div', [
                h('p', text)
              ])
            }
          },
          {
            title: '备注',
            key: 'commend'
          },
          {
            title: '时间',
            width: '200px',
            key: 'createTime'
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: [{ status: 0 }]
      }
    }
  },
  methods: {
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search, ...this.query }
      apiScoredetailList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    }

  },
  mounted () {
    this.search.userId = this.$route.query.userId
    console.log(this.search)
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template{
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.button-border{
  margin-right: 10px;

}
</style>
